export default "__VITE_ASSET__d3da19b1__"